import React from 'react';

export default function Loading({ additionalData }: {
  additionalData: {
    hitClassesLoading?: string;
    itemCount?: number;
  };
}) {
  const { hitClassesLoading, itemCount } = additionalData;
  return (
    <>
      {Array.from({ length: itemCount ?? 12 }, (_, index) => (
        <div key={index} className={`${hitClassesLoading ?? 'w-full'} flex aspect-3/4 overflow-hidden`}>
          <div
            className="group/card size-full relative flex flex-col justify-start no-underline transition-all overflow-hidden rounded-2xl border border-dark/10 gap-6 bg-light animate-pulse"
          >
            <div className="h-8.25 w-18.25 px-4 py-1.5 bg-light rounded-bl-md rounded-br-md border-l border-r border-b border-dark/10 inline-flex justify-start items-center absolute z-2 top-0 left-8" />
            <div className="block aspect-4/3 w-full z-1 overflow-hidden bg-blue-100" />
            <div className="relative z-1 flex flex-col gap-4 mt-auto p-8 pt-0 bg-light">
              <div className="flex justify-start bg-grey-500/50 items-center gap-2 h-5 w-30" />
              <div className="bg-dark/50 w-full h-20" />
              <div className="bg-grey-500/50 w-full h-18" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
